export class FilterVariableCatalog{
    description!: string;
}